module.exports = __webpack_public_path__ + "img/vol-off.336da052.svg";